import { setLanguage } from 'redux-i18n';
export var LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
export var retrieveLanguage = function retrieveLanguage() {
  return function (dispatch, getState) {
    var storedLang = localStorage.getItem('language');
    var browserLang = navigator.language || window.userNavigator.language;
    var translations = getState().i18nState.translations;
    var lang = storedLang ? storedLang : browserLang;

    // Fall back lang i.e. 'en-US' -> 'en'
    if (translations[lang] === undefined && lang.indexOf('-') > -1) {
      var langFallback = lang.split('-')[0];
      if (translations[langFallback]) {
        lang = langFallback;
      } else {
        lang = 'en';
      }
    }
    dispatch(changeLanguage(lang));
  };
};
export var changeLanguage = function changeLanguage(lang) {
  return function (dispatch) {
    // Use setTimeout to dispatch language change due to an issue related with component being wrapped in redux connect function
    // https://github.com/APSL/redux-i18n/issues/73
    setTimeout(function () {
      return dispatch(setLanguage(lang));
    });
    dispatch(languageChanged(lang));
  };
};
export var languageChanged = function languageChanged(lang) {
  return {
    type: LANGUAGE_CHANGED,
    payload: {
      lang: lang
    }
  };
};